var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 21.6875V3H8.3125V21.6875H27ZM27 0.3125C27.7083 0.3125 28.3333 0.583333 28.875 1.125C29.4167 1.66667 29.6875 2.29167 29.6875 3V21.6875C29.6875 22.3958 29.4167 23.0208 28.875 23.5625C28.3333 24.0625 27.7083 24.3125 27 24.3125H8.3125C7.60417 24.3125 6.97917 24.0625 6.4375 23.5625C5.9375 23.0208 5.6875 22.3958 5.6875 21.6875V3C5.6875 2.29167 5.9375 1.66667 6.4375 1.125C6.97917 0.583333 7.60417 0.3125 8.3125 0.3125H27ZM3 5.6875V27H24.3125V29.6875H3C2.29167 29.6875 1.66667 29.4167 1.125 28.875C0.583333 28.3333 0.3125 27.7083 0.3125 27V5.6875H3ZM20.25 12.75L25 19H10.3125L14 14.3125L16.625 17.4375L20.25 12.75Z",
    fill: "#B8B8B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFrame);
export default __webpack_public_path__ + "static/media/image-frame.432d75ee.svg";
export { ForwardRef as ReactComponent };